import { denormalize, normalize, schema } from 'normalizr';

const projectSchema = new schema.Entity(
  'Project',
  {},
  {
    idAttribute: 'Project_ID'
  }
);

const projectGetSchema = new schema.Entity(
  'Transaction',
  {
    Project: projectSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const projectProcessSchema = new schema.Entity(
  'Transaction',
  {
    Project: projectSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    ProjectGet: projectGetSchema,
    ProjectProcess: projectProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    ProjectGet: projectGetSchema,
    ProjectProcess: projectProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

// in root ID:0 = reply from LOAD    ID:1 = transaction being built for PROCESS
export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
